import { ArenaOpsUsdtSchema } from "./arena-ops-filters.dto";
import { z } from "zod";

/**
 * P4b — withdrawal aggregate by status. Distinct panel from the paginated
 * request list (route 17) over the same table; the two are not merged.
 */
export const ArenaOpsMoneyWithdrawalsResponseSchema = z.object({
  byStatus: z.array(z.object({ status: z.string(), count: z.number().int(), amountUsdt: ArenaOpsUsdtSchema })),
  totalCount: z.number().int(),
  totalUsdt: ArenaOpsUsdtSchema,
  /**
   * Sitting past its cooldown, unclaimed. A status breakdown alone cannot show
   * it: these rows are ON_CHAIN like the rest, and the only thing separating
   * them is a timestamp that has passed.
   */
  claimableNowUsdt: ArenaOpsUsdtSchema,
  inCooldownUsdt: ArenaOpsUsdtSchema,
});
export type ArenaOpsMoneyWithdrawalsResponse = z.infer<typeof ArenaOpsMoneyWithdrawalsResponseSchema>;
